export const formatAllottedTime = (allottedTime) => {
  let hours = Math.floor(allottedTime / 60);
  let callTimer;

  if (hours) {
    callTimer = `0${hours}:`;
  } else {
    callTimer = "";
  }
  let minutes = Math.floor(allottedTime % 60);

  callTimer += minutes < 10 ? `0${minutes}:00` : `${minutes}:00`;

  return callTimer;
};
